<script lang="ts" setup>
import { computed } from 'vue'
import { v4 as uuid } from 'uuid'
import type { HomePageConfig } from '../../configs/types'
import ModuleCard from './ModuleCard.vue'
import { resources } from '@/config/brands'

const props = defineProps<{
  module: any
  config: HomePageConfig
  currentTagId: string
  cardClass?: string
  headerClass?: string
  gotoBook: (id: string, firstChapterId?: string) => void
  gotoTags: (id: string) => void
  getCurrentTagResources: (col: any) => any[]
  getCurrentShowTags: (col: any) => any[]
  handleTagClick: (tagId: string) => void
}>()

const tagActiveBg = computed(() => props.config.theme.tagActiveBg)
const tagActiveText = computed(() => props.config.theme.tagActiveText)
const tagInactiveBg = computed(() => props.config.theme.tagInactiveBg)
const tagInactiveText = computed(() => props.config.theme.tagInactiveText)
const hotIconStyle = {
  maskImage: `url(${resources?.tagsIcons?.hotIconRed || '/images/flipnovel/tags/hot-flame.svg'})`,
  WebkitMaskImage: `url(${resources?.tagsIcons?.hotIconRed || '/images/flipnovel/tags/hot-flame.svg'})`,
}

function handleSeeAll() {
  props.gotoTags(props.currentTagId)
}
</script>

<template>
  <ModuleCard
    :title-text="module.showName"
    :action-text-value="config.texts.seeAll"
    :card-class="cardClass"
    :header-class="headerClass"
    @action="handleSeeAll"
  >
    <div class="mt-8px flex flex-wrap gap-7px">
      <div
        v-for="tag in getCurrentShowTags(module)"
        :key="tag.id"
        class="tag-button flex items-center justify-center rounded-full text-12px whitespace-nowrap py-6px px-12px"
        :class="{ 'tag-active': currentTagId === tag.id }"
        @click="handleTagClick(tag.id)"
      >
        <span v-if="tag.isHot" class="rr-hot-icon mr-1" :style="hotIconStyle" aria-hidden="true" />
        {{ tag.tagName }}
      </div>
    </div>

    <div class="mt-12px grid grid-cols-3 gap-10px">
      <div v-for="item in getCurrentTagResources(module)" :key="item.id" @click="gotoBook(item.id, item.firstChapter?.id)">
        <BizBookCover
          :id="uuid()"
          :src="item.contentCoverUrl || ''"
          :extra="{
            module_name: module.showName,
            module_id: module.id,
            module_type: module.columnType,
            ...item,
          }"
          class="rounded-10px"
        />
        <p class="mt-7px text-12px font-medium lh-17px line-clamp-2 text-n-text-1">
          {{ item.contentName }}
        </p>
      </div>
    </div>
  </ModuleCard>
</template>

<style scoped>
.tag-button {
  background-color: v-bind(tagInactiveBg);
  color: v-bind(tagInactiveText);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.tag-button.tag-active {
  background-color: v-bind(tagActiveBg);
  color: v-bind(tagActiveText) !important;
  border-color: transparent;
}

.rr-hot-icon {
  display: inline-block;
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  background-color: currentColor;
  mask-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-position: center;
  mask-size: contain;
  -webkit-mask-size: contain;
}
</style>
